import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxReport from '../util/remote/ajaxReport';
import Notification from '../components/Common/Notification';

const initialState = { 
    reports: null,
    reportInfo: null,
    initials: null,
    currentPage: 1,
    loadingReports: false,
    notify: null,
    metaData: null,
    mounted: false,
    reportId: null,
    selectedReport: null,
    appendingData: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const ReportViewContext = createContext();

export const ReportViewProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   /**
   * Only fetch more pages if page is already mounted
   */
  useEffect(()=>{
    if(state.mounted){
      generateReports(false, state.reportId);
    }
  }, [state.currentPage])

  const generateReports = async(refresh, reportId) => {

    dispatch({ type: 'reportId', payload: reportId});
    dispatch({ type: "mounted", payload: true });
    
        if (refresh) {
            dispatch({ type: "reports", payload: null });
            dispatch({ type: "metaData", payload: null });
            dispatch({ type: 'notify', payload: null });
            dispatch({ type: 'reportInfo', payload: null });
            dispatch({ type: 'initials', payload: null });
            setCurrentPage(1);
        }
        dispatch({ type: 'loadingReports', payload: true });
        dispatch({ type: 'notify', payload: null });
        dispatch({ type: 'appendingData', payload: true });
        const server_response = await ajaxReport.generateReport({
            page: refresh ? 1 : state.currentPage,
          report_id: reportId,

        });
        dispatch({ type: 'loadingReports', payload: false });
        dispatch({ type: 'appendingData', payload: false });

         if (server_response.status === "OK") {
        const newTransactions = server_response.details.data;

        dispatch({
            type: "reports",
            payload: refresh ? newTransactions
                    : state.reports
                    ? [...state.reports, ...newTransactions]
                    : newTransactions
        });

        dispatch({ type: "metaData", payload: server_response.details.meta });
        dispatch({ type: 'reportInfo', payload: server_response.details.report_info });
        dispatch({ type: 'initials', payload: server_response.details.initials });
    } else {
        dispatch({ type: "reports", payload: "404" });
        dispatch({ type: "metaData", payload: "404" });
        dispatch({ type: 'initials', payload: null });
        dispatch({ type: 'notify', payload: <Notification type='warning' message={server_response.message} /> });

    }
    
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
 }

  const setSelectedReport = (report) => {
    dispatch({ type: 'selectedReport', payload: report });
  }


  return(
    <ReportViewContext.Provider value={{
      ...state, 
      dispatch,
      generateReports,
      setCurrentPage,
      setSelectedReport
      }}>
      {children}
    </ReportViewContext.Provider>
  )

}

export const useReportView = ()=>useContext(ReportViewContext);

